import { render, staticRenderFns } from "./CreateNewEvent.vue?vue&type=template&id=30c5e708&scoped=true"
import script from "./CreateNewEvent.vue?vue&type=script&lang=js"
export * from "./CreateNewEvent.vue?vue&type=script&lang=js"
import style0 from "./CreateNewEvent.vue?vue&type=style&index=0&id=30c5e708&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30c5e708",
  null
  
)

export default component.exports